import React from 'react';
import { EditIcon } from '../../../../../../utils/SVGIcon';
import { TextCapitalize } from '../../../../../../utils/TextFormatter';
import cn from '../../../../../../utils/cn';
import { useProductDt } from '../../ProductDetailsProvider';

const limitByArr = [
    {
        key: 'duration',
        title: 'Duration'
    },
    {
        key: 'ppu',
        title: 'Pay Per Unit'
    },
    {
        key: 'lifetime',
        title: 'Life Time'
    }
];

function TableRow({ item, handleSelectPackage, isProductInactive, handleEditClick }) {
    const { packageInfo, isSelected } = useProductDt();

    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo,
                '!bg-secondary-50 hover:!bg-secondary-50 border-transparent':
                    packageInfo?.id === item?.id && isSelected && !item?.demo
            })}
        >
            <td className={packageInfo?.id === item?.id && isSelected ? 'rounded-l-10' : ''}>
                <span>{item?.id}</span>
            </td>
            <td
                className={cn(
                    'group-hover:text-secondary group-hover:font-medium hover:underline !cursor-pointer',
                    {
                        'underline [&>span]:text-secondary [&>span]:font-medium':
                            packageInfo?.id === item?.id && isSelected && !item?.demo
                    }
                )}
                onClick={(ev) => handleSelectPackage(ev, item)}
            >
                <span>{item?.packageName}</span>
            </td>
            <td className="text-left">
                <span>{limitByArr.find((el) => el.key === item?.limitBy)?.title}</span>
            </td>
            <td className="text-left">
                <span>{TextCapitalize(item?.role) || '--'}</span>
            </td>
            <td className="text-center">
                <span>{item?.prices?.length || 0}</span>
            </td>
            <td className="text-center">
                <span>{item?.addons?.length || 0}</span>
            </td>
            <td className="text-center">
                <span className={item?.isPublic ? 'text-secondary' : 'text-warning'}>
                    {item?.isPublic ? 'Yes' : 'No'}
                </span>
            </td>
            <td className="text-center">
                <span className={item?.status === 'active' ? 'text-success' : '!text-warning'}>
                    {TextCapitalize(item?.status) || '--'}
                </span>
            </td>

            <td
                className={`!pr-5 ${
                    packageInfo?.id === item?.id && isSelected ? 'rounded-r-10' : ''
                }`}
            >
                <div className="flex w-full justify-end">
                    <button
                        type="button"
                        onClick={(ev) => handleEditClick(ev, item)}
                        disabled={isProductInactive || item?.demo}
                        className={`size-[31px] p-[7px] rounded-[7px] bg-secondary-100 text-secondary transition-colors disabled:grayscale disabled:cursor-default disabled:select-none disabled:hover:bg-secondary-100 disabled:hover:text-secondary ${
                            packageInfo?.id !== item?.id
                                ? 'hover:bg-secondary hover:text-white'
                                : ''
                        }`}
                    >
                        <EditIcon />
                    </button>
                </div>
            </td>
        </tr>
    );
}
function TableHeader() {
    return (
        <thead>
            <tr className="*:!cursor-default">
                <th scope="col">
                    <span>ID</span>
                </th>
                <th>
                    <span>Package Name</span>
                </th>
                <th scope="col" className="text-left w-38">
                    <span>Limit By</span>
                </th>
                <th scope="col" className="text-left w-[100px]">
                    <span>Role</span>
                </th>
                <th scope="col" className="text-center w-36">
                    <span>Total Prices</span>
                </th>
                <th scope="col" className="text-center w-36">
                    <span>Total Addons</span>
                </th>
                <th scope="col" className="text-center w-20">
                    <span>Public</span>
                </th>
                <th scope="col" className="text-center w-[90px] !px-0">
                    <span>Status</span>
                </th>
                <th scope="col">
                    <span>#</span>
                </th>
            </tr>
        </thead>
    );
}

function TableWeb({ data, isProductInactive, handleSelectPackage, handleEditClick }) {
    return (
        <div className="app_page_table pb-20 overflow-x-auto">
            <table className="bik-table !w-full" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody className="">
                    {data?.map((item) => (
                        <TableRow
                            key={item?.id}
                            item={item}
                            handleSelectPackage={handleSelectPackage}
                            isProductInactive={isProductInactive}
                            handleEditClick={handleEditClick}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
